<template>
    <div style="position: absolute;top: 0;right: 0;bottom: 0;left: 0;display: flex;flex-direction: column">
        <!-- 导航栏 -->
        <van-nav-bar title="已关注用户" left-arrow @click-left="onClickLeft" />
        <van-search v-model="name"  @input="onSearch" />
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="flex: 1;background-color: rgb(247, 248, 250);overflow: scroll">

                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有了"
                        @load="onLoad"
                >
                    <div
                            v-for="(item,index) in list"
                            :key="index"
                            style="background: #fff;display: flex;padding: 5px 10px"
                            @click="onItemClick(item)"
                    >
                        <img :src="item.headImgUrl" width="35" height="35" style="margin: 5px;border-radius: 3px;">
                        <div style="flex: 1;display:flex;flex-direction: column;justify-content: center;overflow: hidden;padding:10px 5px;border-bottom:1px solid #ebedf0">
                            <div style="display:flex;flex-direction: row;justify-content: space-between;overflow: hidden">
                                <span style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.name}}-{{item.nickname}}</span>
                            </div>
                        </div>
                    </div>
                </van-list>

        </van-pull-refresh>
        <van-tabbar v-model="active" @change="onRefresh">
            <van-tabbar-item  icon="home-o">普通用户</van-tabbar-item>
            <van-tabbar-item  icon="chat-o">律师</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>

  import {Toast} from 'vant';
  import axios from '../common/axios';
  import {responseCodes,userTypes} from '../common/const'
  import _ from 'lodash';
  export default {
    name: "Users",
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
        page:1,
        size:50,
        isCloseConsult:false,
        userType: userTypes,
        name:'',
        active:0
      };
    },

    methods:{
      async onLoad() {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
          this.page=1
        }

        if (this.finished){
          return ;
        }

        this.loading = true;
        let body = {}
        body.type = this.active===0?userTypes.customer:userTypes.lawyer
        if (this.name.trim()!==''){
          body.name=this.name.trim()
        }

        try {
          let response = await axios.post(`/fyserve/user/findsUserInfos?page=${this.page}&size=${this.size}`,body)
          let data = response.data;
          if (data.code === responseCodes.success) {
            this.list.push(...data.data)
            console.info(this.list)
            this.page = this.page+1
            if (data.data.length<this.size) {
              this.finished = true;
            }
          }else{
            Toast.fail(data.message);
            this.finished = true
            this.loading = false;
          }
        }catch (e) {
          console.error(e)
          Toast.fail("加载数据失败")
          this.finished = true
          this.loading = false;
        }
        this.loading = false;
      },
      onRefresh() {
        this.refreshing = true;
        this.finished = false;
        this.loading = true;
        this.onLoad();
      },


      onClickLeft() {
        this.$router.back();
      },

      onSearch:_.debounce(function () {
        this.refreshing = true
        this.onRefresh()
      }, 300),
      onItemClick(user){
        console.info(user)
        this.$router.push({
          name:'user',
          params:{
            openId:user.openId
          }
        })
      }
    }
  }
</script>

<style scoped>
    .van-panel__header{
        display: none;
    }
</style>